<template>
  <div class="flow-chart-container">
    <!-- SVG箭头容器 -->
    <svg class="arrow-container" xmlns="http://www.w3.org/2000/svg">
      <!-- 定义箭头样式 -->
      <defs>
        <marker
            id="arrow"
            markerWidth="8"
            markerHeight="8"
            refX="7"
            refY="3"
            orient="auto"
            markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,6 L7,3 z" fill="rgb(6 230 210 / 61%)" />
        </marker>
      </defs>

      <!-- 动态生成箭头连接线 -->
      <template v-for="(item, index) in nodes">
        <template v-if="item.connections && item.connections.length > 0">
          <template v-for="(connection, idx) in item.connections" >
            <!-- 直线连接线 -->
            <line
                v-if="item.y === connection.y"
                :x1="item.x + 45"
                :y1="item.y + 30"
                :x2="connection.x + 45"
                :y2="connection.y + 30"
                class="arrow-line"
                stroke="rgb(6 230 210 / 61%)"
            />
            <!-- 曲线连接线 -->
            <path
                v-else
                :d="generateCurvedPath(item, connection)"
                class="arrow-line curved"
                stroke="rgb(6 230 210 / 61%)"
                fill="none"
            />
          </template>
        </template>
      </template>
    </svg>

    <!-- 节点区域 -->
    <div
        v-for="(node, index) in nodes"
        :key="node.id"
        class="node"
        :style="{
        top: node.y + 'px',
        left: node.x + 'px',
        backgroundColor: node.color
      }"
    >
      <div class="node-icon" :style="{ backgroundColor: node.color }">
        <i :class="node.icon"></i>
      </div>
      <div class="node-label">{{ node.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //nodes: [
      //  //connections: [{ x: 150, y: 30 }, { x: 150, y: 90 }]
      //  {id: 0, label: '客户下单', x: 10, y: 10, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-edit-outline',connections: [{ x: 0, y: 45 }]},
      //  {id: 1, label: '订单管理', x: 10, y: 80, color: '#808080', icon: 'el-icon-edit-outline'},
      //  {id: 2, label: '创建运单', x: 10, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-edit-outline',},
      //  {id: 3, label: '运单管理', x: 140, y: 150, color: '#808080', icon: 'el-icon-takeaway-box',},
      //  {id: 4, label: '订单列表(内部)', x: 240, y: 65, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 5, label: '订单列表(客户)', x: 240, y: 230, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 6, label: '调度订单', x: 340, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 7, label: '报价管理', x: 440, y: 65, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 8, label: '指派管理', x: 440, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 9, label: '抢单管理', x: 440, y: 230, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 10, label: '在途跟踪', x: 540, y: 150, color: '#808080', icon: 'el-icon-document-checked',},
      //  {id: 11, label: '实时监控', x: 640, y: 25, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 12, label: '已出车', x: 640, y: 105, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 13, label: '已到达', x: 640, y: 205, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 14, label: '已装货', x: 640, y: 305, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 15, label: '已卸货', x: 640, y: 405, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 16, label: '签收管理', x: 740, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //  {id: 17, label: '回单管理', x: 840, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked',},
      //],

      nodes: [
        {id: 0, label: '客户下单', x: 10, y: 10, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-edit-outline', connections: [{ x: 10, y: 80 }]},
        {id: 1, label: '订单管理', x: 10, y: 80, color: '#808080', icon: 'el-icon-edit-outline', connections: [{ x: 10, y: 150 }]},
        {id: 2, label: '创建运单', x: 10, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-edit-outline', connections: [{ x: 140, y: 150 },]},
        {id: 3, label: '运单管理', x: 140, y: 150, color: '#808080', icon: 'el-icon-takeaway-box', connections: [
            { x: 340, y: 150 },
            { x: 240, y: 65 },
            { x: 240, y: 230 }
          ]},
        {id: 4, label: '订单列表(内部)', x: 240, y: 65, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 340, y: 150 }]},
        {id: 5, label: '订单列表(客户)', x: 240, y: 230, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 340, y: 150 }]},
        {id: 6, label: '调度订单', x: 340, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [
            { x: 440, y: 150 },

          ]},
        {id: 7, label: '报价管理', x: 440, y: 65, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 540, y: 150 }]},
        {id: 8, label: '指派管理', x: 440, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 540, y: 150 }]},
        {id: 9, label: '抢单管理', x: 440, y: 230, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 540, y: 150 }]},
        {id: 10, label: '在途跟踪', x: 540, y: 150, color: '#808080', icon: 'el-icon-document-checked', connections: [
            { x: 640, y: 25 },
            { x: 640, y: 105 },
            { x: 640, y: 205 },
            { x: 640, y: 305 },
            { x: 640, y: 405 }
          ]},
        {id: 11, label: '实时监控', x: 640, y: 25, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 740, y: 150 }]},
        {id: 12, label: '已出车', x: 640, y: 105, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 740, y: 150 }]},
        {id: 13, label: '已到达', x: 640, y: 205, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 740, y: 150 }]},
        {id: 14, label: '已装货', x: 640, y: 305, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 740, y: 150 }]},
        {id: 15, label: '已卸货', x: 640, y: 405, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 740, y: 150 }]},
        {id: 16, label: '签收管理', x: 740, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: [{ x: 840, y: 150 }]},
        {id: 17, label: '回单管理', x: 840, y: 150, color: 'rgb(6 230 210 / 61%)', icon: 'el-icon-document-checked', connections: []},
      ]
    };
  },
  methods: {
    // 生成曲线路径
    generateCurvedPath(source, target) {
      const startX = source.x + 45;
      const startY = source.y + 30;
      const endX = target.x + 45;
      const endY = target.y + 30;

      // 计算控制点
      const dx = Math.abs(endX - startX);
      const dy = Math.abs(endY - startY);
      const controlX = startX + dx * 0.5;
      const controlY1 = startY;
      const controlY2 = endY;

      return `M${startX},${startY} C${controlX},${controlY1} ${controlX},${controlY2} ${endX},${endY}`;
    }
  }
}
</script>

<style scoped>
.flow-chart-container {
  position: relative;
  width: 1200px;
  height: 400px;
  margin-top: 20px;
  border: 1px solid #eaeaea;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.arrow-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.arrow-line {
  stroke-width: 1.5;
  marker-end: url(#arrow);
}

.arrow-line.curved {
  stroke-width: 1.5;
}

.node {
  position: absolute;
  border-radius: 15px;
  width: 80px;
  text-align: center;
  cursor: pointer;
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: bold;
  transition: all 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.node:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.node-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 16px;
}

.node-label {
  font-size: 10px;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  text-align: center;
}
</style>
